import { isAndroidApp, isEventbriteTLD, isIosApp } from '.';
import { CheckoutState } from '../../state';

enum Platform {
    android = 'Android',
    ios = 'iOS',
    thirdParty = 'Third-party',
    web = 'Web',
}

export const getPlatformLabel = (state: CheckoutState) => {
    if (isAndroidApp(state)) {
        return Platform.android;
    }
    if (isIosApp(state)) {
        return Platform.ios;
    }
    return isEventbriteTLD(state) ? Platform.web : Platform.thirdParty;
};
